<template>
  <section class="full-height">
    <div class="card email-card">
      <div class="content">
        <a href="mailto:seuemail@seudominio.com">
        Entre em contato
        <br/>
        </a>
        <small>
          e faça seu orçamento
        </small>
        <br />
        <div class="d-flex justify-content-center">
        <a style="margin: 10px 15px;" href="mailto:seuemail@seudominio.com">
          <img
            style="width: 45px;"
            src="https://upload.wikimedia.org/wikipedia/commons/4/4e/Gmail_Icon.png" alt="Logo whatsapp" />
        </a>
        
        <a style="margin: 10px 15px;" target="blank" rel="noopener" href="https://api.whatsapp.com/send?phone=55451111111111">
          <img
            style="width: 45px;"
            src="https://is4-ssl.mzstatic.com/image/thumb/Purple112/v4/18/21/80/18218099-3705-041e-53c0-e8ad1b771f7c/electron.png/1024x1024.jpg" alt="Logo whatsapp" />
        </a>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style scoped>
  section {
    background: url('https://abs.twimg.com/sticky/illustrations/lohp_en_1302x955.png');
    background-size: cover;
    background-position: center top;
  }

  .lkc-logo {
    float:left;
    padding: 50px 0px 0px 50px;
  }

  .title {
    font-family: Times New Roman;
    font-size: 30px;
    line-height: 32px;

  }

  .subtitle {
    font-family: Times New Roman;
    font-size: 20px;
    line-height: 23px;
    /* identical to box height */
  }
.full-height {
    display: flex;
    justify-content: center;
    align-items: center;
}

  .email-card {
    height: 120px;
    width: 300px;
    border-radius: 6px;
    padding: 10px;
    box-sizing: border-box;

    background: white;
    box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  }

  .email-card .content {
    height: 100%;
    vertical-align: middle;
    font-family: Open Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 18px;
    /* identical to box height */

    text-align: left;
    vertical-align: middle;

  }

  a {
    color: black;
  }

  a:hover {
    color: black;
    text-decoration: none;
  }

    @media (max-width: 575.98px) {
      .lkc-logo {
        padding: 20px 0px 0px 20px;
      }

      .title {
        font-size: 17px;
        line-height: 19px;
    
      }

      .subtitle {
        font-size: 11.4px;
        line-height: 15px;
      }

      .email-card {
        margin: 20px 20px 0px 00px;
        height: 36px;
        width: 205px;
      }
    }
</style>
